import { IAppAction } from "../appAction";
import { adsActions } from "./ads-action";
import { getDefaultAdsState, IAdsState } from "./ads-state";

const handlers = {
  [adsActions.FETCH_SLOTS]: (
    state: IAdsState
  ): IAdsState => {
    return { ...state, slotsIsLoading: true };
  },
  [adsActions.FETCH_SLOTS_SUCCESS]: (
    state: IAdsState,
    slots: string[]
  ): IAdsState => {
    return { ...state, slots: slots, slotsIsLoading: false, slotsError: null };
  },
  [adsActions.FETCH_SLOTS_ERROR]: (
    state: IAdsState,
    error: Error
  ): IAdsState => {
    return { ...state, slotsError: error, slotsIsLoading: false };
  },
};

export const adsReducer = (
  state: IAdsState = getDefaultAdsState(),
  action: IAppAction
) => {
  return Object.prototype.hasOwnProperty.call(handlers, action.type) ?
    handlers[action.type](state, action.payload) : state;
};
